import React, {FC, memo, useEffect, useState} from "react";
import './ChatSettingsForm.css'
import { GridAreaContentLayout } from "../content/GridAreaContentLayout";
import {GridAreaContentLayoutTextField} from "../content/GridAreaContentLayoutTextField";
import {GridAreaContentLayoutButton} from "../content/GridAreaContentLayoutButton";
import {useStateValue} from "../state-provider/StateProvider";
import {setGridAreaContent, setUserEmail} from "../app/App.action";
import {LiveChatDataObject, ws} from "../../events/ws";
import {sendToWidget} from "../../utils/postMessages";
import {log} from "../../utils/log";
import {useLiveChat} from "./useLiveChatProfile";
import { BsChat } from "react-icons/bs";
import { IoIosReturnLeft } from "react-icons/io";
const ChatSettingsFormComponent: FC<{
  organizationId: string
  experienceId: string
  referenceId: string
}> = ({
  organizationId,
  experienceId,
  referenceId
}) => {

  const [username, setUsername] = useState<string>()
  const [email, setEmail] = useState<string>()

  const liveChat = useLiveChat(organizationId, referenceId)

  const [{
    translations,
  }, dispatch] = useStateValue()


  useEffect(() => {
    if (liveChat) {
      setUsername(liveChat.profile.name)
      setEmail(liveChat.profile.details ? (translations['LiveChatEmailAlreadySetLabel'] || "Already set") : "")
    }
  }, [liveChat])

  const joinChat = () => {
    try {
      let usernameToUse = username?.trim()
      let emailToUse = email?.trim()
      if (!liveChat && usernameToUse) {
        const timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone
        ws.sendJoinLiveChat(
          organizationId,
          referenceId,
          usernameToUse,
          emailToUse,
          timezone,
        )
        dispatch(setUserEmail({ userEmail: emailToUse }))
        sendToWidget({ type: 'update-user-email', value: emailToUse })
      } else if (liveChat && !liveChat.profile.details && emailToUse) {
        ws.sendSetEmailOnLiveChat(
          organizationId,
          referenceId,
          emailToUse,
        )
        dispatch(setUserEmail({ userEmail: emailToUse }))
        sendToWidget({ type: 'update-user-email', value: emailToUse })
      }
      dispatch(setGridAreaContent('LiveChat'))
    } catch (e) {
      log(`Error sending chat join request`, e)
    }
  }

  return (
    <GridAreaContentLayout
      heading={translations['LiveChatInputNameTitle'] || "Joining the chat"}
      footer={(
        <GridAreaContentLayoutButton
          onClick={joinChat}
          label={Boolean(liveChat?.profile?.details) ? (translations['LiveChatButtonReturnLabel'] || "Return") : (translations['LiveChatButtonJoinLabel'] || "Join the chat")}
          icon={Boolean(liveChat?.profile?.details) ? <IoIosReturnLeft/> : <BsChat/> }
          disabled={!username?.trim()}
        />
      )}
    >
      <GridAreaContentLayoutTextField
        label={translations['LiveChatInputNameLabel'] || "Set your user name"}
        value={username}
        setValue={setUsername}
        disabled={Boolean(liveChat?.profile)}
      />
      <div style={{ margin: "10px"}}></div>
      <GridAreaContentLayoutTextField
        label={translations['LiveChatInputEmailLabel'] || "Set your email (for raffle and replies)"}
        value={email}
        setValue={setEmail}
        disabled={Boolean(liveChat?.profile?.details)}
      />
    </GridAreaContentLayout>
  )
}

export const ChatSettingsForm = memo(ChatSettingsFormComponent)